import uuid from "uuid/v4"
import identity from "ramda/src/identity"
import {throttle} from "hurdak/src/core"
import storage from "hurdak/src/storage"
import Db from "modules/db/state"
import Api from "modules/domain/api"
import history from "utils/history"
import {RESET_AUTO_LOGOUT_TIMER} from "app/core/constants"
import Core from "app/core/state"

const autoLogoutStorage = storage.cursor("last-auto-logout-reset", new Date().valueOf())

export const autoLogoutMiddleware = store => {
  let autoLogoutTimeout

  const resetTimer = throttle((autoLogoutMinutes, propagate) => {
    // Cancel next logout
    clearTimeout(autoLogoutTimeout)

    // Schedule next auto logout for n minutes from last action
    const timeSinceLastAction = new Date().valueOf() - autoLogoutStorage.get()
    const timeout = autoLogoutMinutes * 60000 - timeSinceLastAction

    autoLogoutTimeout = setTimeout(() => store.dispatch(Core.logoutUser()), Math.max(1, timeout))

    // Propagate an action across tabs
    // Gotta include an unique thing so that the storage listener gets called
    if (propagate) {
      store.dispatch({type: RESET_AUTO_LOGOUT_TIMER, payload: {ident: uuid()}})
    }
  }, 10000)

  const beat = actionType => {
    const db = Db.select.interface(store.getState())
    const users = db.active("user")
    const user = Core.select.user(store.getState())
    const {autoLogoutMinutes} = Core.select.store(store.getState()) || {}

    // Only do this if they're logged in and there is someone else who might log in
    if (autoLogoutMinutes && user && users.length > 1) {
      resetTimer(autoLogoutMinutes, actionType !== RESET_AUTO_LOGOUT_TIMER)
    }

    // Keep track of last reset time outside the throttle so it's always up
    // to date. Skip it for the initial boot action
    autoLogoutStorage.set(new Date().valueOf())
  }

  // Watch for mouse move events to get high granularity for read-only activities
  window.addEventListener("mousemove", () => beat(null))

  // Watch actions as well, so we can avoid logging out for idle times with polling
  return next => action => {
    beat(action.type)

    next(action)
  }
}

export const impersonateMiddleware = ({dispatch}) => {
  window.impersonate = (token, store) => {
    // Clear everything out so that intercom shuts down properly
    dispatch(Core.resetAppState())

    // Give intercom time to shut down?
    return new Promise(resolve => {
      setTimeout(async () => {
        const auth = await dispatch(Api.session.post("impersonate", {token, store}))
        await dispatch(Core.setAuth({...auth, impersonating: true}))

        history.push("/")
        resolve()
      }, 1000)
    })
  }

  return identity
}
